import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-control_group_icon",
  "use": "icon-control_group_icon-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-control_group_icon\"><path d=\"M320 64h320v256H320zM384 704h192v256H384zM0 704h192v256H0zM768 704h192v256h-192zM128 512h320v128h64V512h320v128h64V448H512V384H448v64H64v192h64V512z\" p-id=\"2577\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/control/control_group_icon.svg
// module id = 3enY
// module chunks = 24